import { render } from "./EmployeeRoleEditor.vue?vue&type=template&id=305850d0&scoped=true&ts=true"
import script from "./EmployeeRoleEditor.vue?vue&type=script&lang=ts"
export * from "./EmployeeRoleEditor.vue?vue&type=script&lang=ts"

import "./EmployeeRoleEditor.vue?vue&type=style&index=0&id=305850d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305850d0"]])

export default __exports__